import { render, staticRenderFns } from "./SKUDiscountSettings.vue?vue&type=template&id=63e68f21&scoped=true&"
import script from "./SKUDiscountSettings.vue?vue&type=script&lang=js&"
export * from "./SKUDiscountSettings.vue?vue&type=script&lang=js&"
import style0 from "./SKUDiscountSettings.vue?vue&type=style&index=0&id=63e68f21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e68f21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e68f21')) {
      api.createRecord('63e68f21', component.options)
    } else {
      api.reload('63e68f21', component.options)
    }
    module.hot.accept("./SKUDiscountSettings.vue?vue&type=template&id=63e68f21&scoped=true&", function () {
      api.rerender('63e68f21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/components/SKUDiscountSettings.vue"
export default component.exports